<script lang="ts">
  export let size = '30px';

  const style: Record<string, string> = {};
  if (size) {
    style.width = size;
    style.height = size;
  }
</script>

<div class={`loading-v ${$$restProps.class || ''}`}>
  <span class="loading-v-icon" style:width={style.width} style:height={style.height}>
    <svg class="loading-v-circle" viewBox="25 25 50 50">
      <circle cx="50" cy="50" r="20" fill="none" />
    </svg>
  </span>
  <span class="loading-v-text">
    <slot />
  </span>
</div>

<style lang="scss">
  @keyframes van-rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes van-circular {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120;
    }
  }

  .loading-v {
    position: relative;
    color: #c8c9cc;
    font-size: 0;
    vertical-align: middle;

    .loading-v-icon {
      position: relative;
      display: inline-block;
      width: 30px;
      max-width: 100%;
      height: 30px;
      max-height: 100%;
      vertical-align: middle;
      animation: van-rotate 0.8s linear infinite;
      animation-duration: 2s;

      .loading-v-circle {
        circle {
          animation: van-circular 1.5s ease-in-out infinite;
          stroke: currentColor;
          stroke-width: 3;
          stroke-linecap: round;
        }
      }
    }

    .loading-v-text {
      display: inline-block;
      margin-left: 8px;
      color: #969799;
      font-size: 14px;
      vertical-align: middle;
    }
  }
</style>
